// Status vocabulary shared by the request form (the requester's own list) and
// the admin dashboard. Keep in sync with STATUSES in
// server/routes/api/FeatureRequests/featureRequestsHandler.js.
export const STATUS_META = {
  new: { label: "New", chip: "info" },
  planned: { label: "Planned", chip: "primary" },
  in_progress: { label: "In Progress", chip: "warning" },
  completed: { label: "Completed", chip: "success" },
  declined: { label: "Declined", chip: "default" },
};

export const STATUS_ORDER = [
  "new",
  "planned",
  "in_progress",
  "completed",
  "declined",
];

export const statusLabel = (status) => STATUS_META[status]?.label || "New";
